import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./accountAlerts.css";
import LinkButton from "../../Shared/LinkButton/index";
import { LoadingState } from "../../helpers/enum";
import AccountCategory from './accountCategory';
import BackButton from '../../Shared/BackButton';
import { Header } from '../../Shared';
import { isMobile } from '../../helpers/utils';
import LoadingMask from "../../Shared/LoadinngMask/LoadingMask";

class AccountAlertsPage extends Component {
    constructor(props) {
        super(props);
        this.accountno = props.match.params.accountno;
        this.nickname = props.match.params.nickname;
        this.name = props.match.params.name;
    }

    componentWillMount() {
        this.props.getAccountAlertTypes(this.accountno);
    }

    componentDidMount() {
        this.props.getAccountAlertRegistrations(this.accountno);
        if (this.props.bankingAlertsState !== LoadingState.FULFILLED) {
            this.props.bankingAlerts();
            this.props.accountAlerts();

        }
    }

    componentDidUpdate() {
        setTimeout(() => {
            var root = document.getElementById("root");

            var _event = {};

            _event = {
                name: 'END_SETTING_HEIGHT',
                height: root.parentElement.parentElement.offsetHeight
            };

            //Post END Height Event for OLB 
            window.parent.postMessage(_event, '*')
        },
            0)
    };

    isEnabled = (alertRegistrations, id) => {
        var regs = alertRegistrations.find(reg => {
            return reg.deliveryMethod === id;
        });
        if (regs) {
            return [regs];
        }
        return [];
    }

    handleCheckBox = (value, item, id, alertCriteria, alertId) => {
        if (value) {
            this.props.removeAlertRegistration({
                deliveryAddress: alertId,
                accountNumber: this.accountno,
                alertType: item.alertTypeName,
                typeName: item.name
            });
        } else {
            this.props.addAlertRegistration({
                deliveryMethod: id,
                accountNumber: this.accountno,
                alertType: item.alertTypeName,
                alertCriteria: alertCriteria,
                typeName: item.name
            })
        }
    }

    render() {
        const { accountAlertPreferencesReducer = {} } = this.props;
        const { accountAlertTypes = {} } = this.props;
        // const { accountAlertState = {} } = this.props;
        const textItems = this.props.deliveryAddresses.filter(s => s.channel === "SMS" && s.phoneNumber);
        textItems.forEach((item, i) => {

            item.address = item.countryCode +
                '-' + item.areaCode +
                '-' + item.phoneNumber;

            item.displayValue = item.countryCode +
                '-' + item.areaCode +
                '-' + item.phoneNumber.substring(0, 3) +
                '-' + item.phoneNumber.substring(3, 7)
        });

        const emailItems = this.props.deliveryAddresses.filter(
            s => s.channel === "Email"
        );
        const pushItems = this.props.deliveryAddresses.filter(
            s => s.channel === "Push" && s.nickname
        );
        pushItems.forEach((item, i) => {
            item.address = item.nickname;
        })


        if (!accountAlertPreferencesReducer.loadingState || accountAlertPreferencesReducer.loadingState === LoadingState.PENDING) {
            return <LoadingMask ctrlCss="fullpage" NavigationLink={`Account Alerts for ${this.name.substr(-5)}`} />;
        }
        else if (accountAlertPreferencesReducer.loadingState === LoadingState.FULFILLED && accountAlertTypes.loadingState === LoadingState.FULFILLED) {
            return (
                <div>
                    <div aria-live="polite">
                        {this.props.accountAlertState === LoadingState.PENDING && <LoadingMask ctrlCss="overlay" />}
                    </div>
                    <div className={isMobile() ? `mobilecontainer-box mobile-font-family` : `container-box`} >
                        <BackButton
                            href="#/landingPage"
                            text=" Alerts"
                        />
                        <Header
                            mainHeading={`${this.name}`}
                            subHeading={`Set Up Account Alerts` + (isMobile() ? ` for ${this.name.substr(-5)}` : '')}
                            subHeadingDesc={"Configure account activity alerts and select how you'd like to receive them."}

                        />
                        {!isMobile() ?
                        <div className="comp-header comp-header-subHeader-desc-prescription italic" role="text">
                            <p id="DescriptionText2">If you do not see your email or phone number listed, please visit {" "}
                                <a aria-label="Add/Edit Delivery Methods" className="AppLink desktop bold underline" href="#/alertPreferences/addOrEditMethodComponent"> Add/Edit Delivery Methods.
                                </a>
                            </p> 
                        </div> : `` }
                        <div className="align-hr-item" />
                        {
                            accountAlertTypes.items.map((item, index) => {
                                const alertRegistrations = accountAlertPreferencesReducer.items.filter(
                                    s => s.typeName === item.name
                                );

                                const categories = [];
                                const categoryContent = [];

                                item.deliveryChannels.forEach(deliveryChannnel => {
                                    if (deliveryChannnel === "Push") {
                                        categories.push("Push Notification");
                                        categoryContent.push(pushItems);
                                    } else if (deliveryChannnel === "SMS") {
                                        categories.push("Text Message");
                                        categoryContent.push(textItems);
                                    }
                                    else if (deliveryChannnel === "Email") {
                                        categories.push("Email");
                                        categoryContent.push(emailItems);
                                    }
                                })

                                return (
                                    <AccountCategory
                                        key={'Accordion' + index + '-' + alertRegistrations.length}
                                        item={item}
                                        alertRegistrations={alertRegistrations}
                                        accountno={this.accountno}
                                        categories={categories}
                                        categoryContent={categoryContent}
                                        isEnabled={this.isEnabled}
                                        handleCheckBox={this.handleCheckBox}
                                        removeAllAccountRegistrations={this.props.removeAllAccountRegistrations}
                                        updateAlertCriteria={this.props.updateAlertCriteria}
                                    />
                                )
                            })}
                        <div className="padding-top">
                            <LinkButton
                                text="Add / Edit Delivery Methods"
                                href="#/alertPreferences/addOrEditMethodComponent"
                            />
                        </div>
                    </div>
                </div>

            );
        } else {
            return <LoadingMask ctrlCss="fullpage" />;
        }
    }
}

export default withRouter(AccountAlertsPage);
